export default __webpack_public_path__ + "static/media/TuyaTempHumid.e999736e.png";